import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import clsx from 'clsx'

const styles = theme => ({

    chipTagStatus: {
        padding: '0 16px',
        lineHeight: '30px',
        color: 'black',
        fontWeight: 'bold',
        height: 'auto',
        width: 'auto',
        fontSize: '12px',
        minWidth: 102
    },
    spanLabel: {
        textAlign: 'center',
        width: '100%'
    },
    chip: {
        width: '10px',
        minWidth: '10px',
        height: '10px',
    },
    small: {
        display: 'inline-flex',
        borderRadius: '30px',
        lineHeight: '22px'
    },
    green: {
        backgroundColor: '#daf7df',
        border: '1px solid ' + theme.colors.labels.green[200]
    },
    greenAlt: {
        backgroundColor: 'white',
        border: '1px solid ' + theme.colors.labels.green[200]
    },
    white: {
        backgroundColor: 'white',
        border: '1px solid #B5CBE3',
        color: '#666666'
    },
    blue: {
        backgroundColor: '#CFE0FC',
        border: '1px solid #B5CBE3',
        color: '#666666'
    },
    red: {
        backgroundColor: '#F46F6F',
        border: '1px solid ' + theme.colors.labels.red[200],
        color: '#666666 !important'
    },
    redAlt: {
        backgroundColor: 'white',
        border: '1px solid ' + theme.colors.labels.red[200]
    },
    yellow: {
        backgroundColor: '#F7E28D',
        border: '1px solid ' + theme.colors.labels.yellow[200],
        color: '#666666'
    },
    yellowAlt: {
        backgroundColor: 'white',
        border: '1px solid ' + theme.colors.labels.yellow[200]
    },
    grey: {
        backgroundColor: theme.colors.secondary[100],
        border: '1px solid ' + theme.colors.secondary[200],
        colors: '#666666'
    }
});

function ChipTagStatus(props) {

    const { classes, className, label, color, rightIcon } = props;

    return (
        <div key={"ChipTagStatus" + Math.floor(Math.random() * 100)}
            className={clsx(className, (label ? classes.chipTagStatus : classes.chip), classes[color], classes.small)}
        >
            <div className={classes.spanLabel}>{label}</div>
            {rightIcon}
        </div>
    );
}

export default withStyles(styles)(ChipTagStatus);